import * as React from 'react'
import { styled } from 'next-yak'

import * as S from '../../styles'
import { PointsTagColors } from '../../styles/tag'

export type PointsProps = {
  backgroundColor?: PointsTagColors
  children: number
} & React.HTMLAttributes<HTMLDivElement>

function PointsComponent({ children, backgroundColor, ...props }: PointsProps): React.ReactElement<PointsProps> {
  return (
    <S.tag.Points backgroundColor={backgroundColor} {...props}>
      {children}
    </S.tag.Points>
  )
}

export const Points = styled(PointsComponent)<PointsProps>``
Points.displayName = 'Points'
